const React = require('react');
const Button = require('components/button');
const Row = require('components/row');
const Col = require('components/col');
const FormInput = require('components/form-input');
const api = require('utils/api-controller');
const toast = require('utils/toast-service');

module.exports = React.createClass({

  getInitialState(){
    return {
      newPassword: '',
      confirmation: ''
    };
  },

  submitForm(ev){
    ev.preventDefault();
    api.changePass( this.state.curPassword, this.state.newPassword).then(function(){
      window.location.hash = "#/";
      toast.toast('Senha alterada com sucesso.');
    });
  },

  linkState(propName){
    var self = this;
    return {
      value: this.state[propName],
      requestChange(newValue){
        var data = {};
        data[propName] = newValue;

        self.setState(data);
      }
    };
  },

  render(){

    var btnDisabled = !this.state.newPassword || this.state.confirmation !== this.state.newPassword;
    var ctrlSenhaAtual, btnMudar, buttons, mensagem;

    btnMudar = <button className="btn btn-lg btn-primary form-control input-lg" type="submit" disabled={btnDisabled}>Mudar Senha</button>;

    if (api.profile.statusSenha !== '2') {
      mensagem = 'Você deseja modificar a sua senha atual. Por favor, informe corretamente os dados abaixo e clique no botão mudar senha.';
      ctrlSenhaAtual = <Row><FormInput autoFocus={true} size='sm-12' className="form-control input-lg" valueLink={this.linkState('curPassword')} type="password" label="Senha Atual" /></Row>
      buttons = (<Row>
        <Col size="sm-6">{btnMudar}</Col>
        <Col size="sm-6"><a href="#/" role="button" className="btn btn-lg btn-default form-control input-lg" type="submit">Cancelar</a></Col>
      </Row>)
    } else {
      if (api.isResettingPass()) {
        mensagem = "Você está acessando o link para reiniciar sua senha, que foi enviado por e-mail. Por favor, informe e confirme a nova senha abaixo.";
      } else {
        mensagem = 'É necessário efetuar a alteração da senha, pois a atual é temporária.';
      }
      buttons = (<Row>
        <Col size="sm-12">{btnMudar}</Col>
      </Row>)
    }

    return (
      <div className="site-body">
        <div className="container">
          <div className="login-header">
            <Row>
              <Col size="sm-12" className="text-center">
                <img src="/logotipo" alt=""/>
              </Col>
            </Row>
            <Row>
              <Col size="sm-12" className="text-center">
                <h1>Bem vindo ao {window.systemName}</h1>
              </Col>
            </Row>

            <p>{mensagem}</p>
          </div>
          <div className="row">
            <div className="col-sm-6 col-sm-offset-3 login-box">
              <form onSubmit={this.submitForm}>
                <Row><FormInput size='sm-12' className="form-control input-lg" value={api.profile.login} type="text" label="Usuário" readOnly={true} /></Row>
                {ctrlSenhaAtual}
                <Row><FormInput size='sm-12' className="form-control input-lg" valueLink={this.linkState('newPassword')} type="password" label="Nova Senha"  /></Row>
                <Row><FormInput size='sm-12' className="form-control input-lg" valueLink={this.linkState('confirmation')} type="password" label="Confirmação" /></Row>
                <hr/>
                {buttons}
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
});


/** WEBPACK FOOTER **
 ** ./src/views/login/mudar-senha.js
 **/